import CategoriesBase from '../../../shared/duck/helpers/CategoriesBase'
import {categories, itemsListCategories} from './FLowOrderState'

export class FlowOrdersCategories extends CategoriesBase {    
    constructor(){
        super(categories, itemsListCategories)
    }
}